import { Injectable, Inject } from '@angular/core';
import * as Immutable from "immutable";

import { AbstractSearchDataMessage } from "../../models/responses/messages";
import { SearchDataMemorizer } from "./searchDataMemorizer";
import { ManagedSubscription, SubscriptionOptions } from "../../../../shared/managedSubscription";
import { ManagedSubject } from "../../../../shared/managedSubject";
import { AppStoreSubscriptionManager } from "../appStoreSubscriptionManager";

@Injectable()
export class SearchDataMessageProvider {

  constructor(
    public appStoreSubscriptionManager: AppStoreSubscriptionManager,
    @Inject(SearchDataMemorizer) public searchDataMemorizer: SearchDataMemorizer
  ) {
  }

  public onMessages<T extends AbstractSearchDataMessage>(messageClassName: string, subscriptionOptions: SubscriptionOptions<Immutable.List<T>>): ManagedSubscription {
    return this.createStoreSubscription<Immutable.List<T>>(messageClassName, this.searchDataMemorizer.getMessagesMemorizer<T>(messageClassName), subscriptionOptions);
  }

  public createStoreSubscription<T>(identifier: string, memorizer: () => T, subscriptionOptions: SubscriptionOptions<T>): ManagedSubscription {

    let managedSubject: ManagedSubject<T> = this.appStoreSubscriptionManager.getOrCreateStoreSubject<T>(identifier, memorizer, false, 1, false);
    return managedSubject.subscribe(subscriptionOptions);
  }

}